import { render } from "./UnconditionalNextOfKinStep.vue?vue&type=template&id=47f5f471&scoped=true"
import script from "./UnconditionalNextOfKinStep.vue?vue&type=script&lang=js"
export * from "./UnconditionalNextOfKinStep.vue?vue&type=script&lang=js"

import "./UnconditionalNextOfKinStep.vue?vue&type=style&index=0&id=47f5f471&lang=scss&scoped=true"
import "./UnconditionalNextOfKinStep.vue?vue&type=style&index=1&id=47f5f471&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f5f471"]])

export default __exports__